





















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
    name: 'StepTemp'
})
export default class StepTemp extends Vue {
    @Prop({ default: 0 }) active!: number;
    @Prop({ default: () => { return [] } }) stepList!: { key?: number; title?: string }[] // 步骤列表
}
